import React from "react";
import styled from "styled-components";
import {
  Home,
  GettingStarted,
  ActivityIndicator,
  Alert,
  Text,
  TextInput,
  Image
} from "./pages";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Redirect,
  NavLink as OLink,
  Route,
  Switch
} from "react-router-dom";
import Drawer from "./components/Drawer";
import { MdMenu } from "react-icons/md";
import { IconContext } from "react-icons";

const SideBar = styled.div`
  position: fixed;
  height: 100vh;
  width: 16vw;
  background-color: #f8f9fa;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  padding: 2vw;
  box-sizing: border-box;

  @media (max-width: 600px) {
    display: none;
  }
`;

const ContentArea = styled.div`
  height: 100vh;
  width: 84vw;
  float: right;

  @media (max-width: 600px) {
    float: inherit;
    width: 100vw;
  }
`;

const Link = styled(OLink).attrs(() => ({
  activeStyle: {
    color: "#FF0080",
    fontWeight: "400"
  }
}))`
  text-decoration: none;
  :hover {
    color: #000;
  }
  font-family: "Roboto", sans-serif;
  color: #888888;
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left;
  font-weight: 300;
`;

const Bar = styled.div`
  width: 90%;
  height: 1px;
  background-color: #dfe0e3;
  margin-top: 24px;
  margin-bottom: 24px;
`;

const HamBurger = styled.div`
  display: none;
  @media (max-width: 600px) {
    display: flex;
    padding: 20px;
  }
`;

class App extends React.Component {
  state = { expanded: false, mounted: false };

  handleHamBurgerToggle = () => {
    const newState = !this.state.expanded;
    if (!newState) setTimeout(() => this.setState({ mounted: false }), 300);
    else this.setState({ mounted: true });
    this.setState({ expanded: newState });
  };

  render() {
    const { expanded, mounted } = this.state;

    return (
      <Router>
        <HamBurger>
          <IconContext.Provider value={{ color: "#FF0080", size: 30 }}>
            <MdMenu onClick={this.handleHamBurgerToggle} />
          </IconContext.Provider>
        </HamBurger>
        <SideBar>
          <Link to="/" exact={true}>
            Home
          </Link>
          <Link to="/getting-started" exact={true}>
            Getting Started
          </Link>
          <Bar />
          <Link to="/activity-indicator" exact={true}>
            ActivityIndicator
          </Link>
          <Link to="/alert" exact={true}>
            Alert
          </Link>
          <Link to="/image" exact={true}>
            Image
          </Link>
          <Link to="/text" exact={true}>
            Text
          </Link>
          <Link to="/textinput" exact={true}>
            TextInput
          </Link>
        </SideBar>
        <ContentArea>
          <Switch>
            <Route path="/" component={Home} exact={true} />
            <Route
              path="/getting-started"
              component={GettingStarted}
              exact={true}
            />
            <Route
              path="/activity-indicator"
              component={ActivityIndicator}
              exact={true}
            />
            <Route path="/alert" component={Alert} exact={true} />
            <Route path="/image" component={Image} exact={true} />
            <Route path="/text" component={Text} exact={true} />
            <Route path="/textinput" component={TextInput} exact={true} />
          </Switch>
        </ContentArea>
        <Drawer
          expanded={expanded}
          mounted={mounted}
          onToggle={this.handleHamBurgerToggle}
        />
      </Router>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"));
